import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

import { setEventTypeAndReload } from './filters_actions';
import connectWithStore from '../../../hocs/connectWithStore';

class EventTypeFilter extends React.Component {
  handleEventTypeChange = (selectedOption) => {
    this.props.setEventTypeAndReload(selectedOption);
  }

  render() {
    const { eventTypes } = this.props;

    const eventTypeOptions = eventTypes.map((s) => ({value: s.value, label: s.label }));

    return (
      <li style={{width: '200px'}}>
        <Select className="select" onChange={this.handleEventTypeChange}
          options={eventTypeOptions} defaultValue={eventTypeOptions[0]} menuPortalTarget={document.body}  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}/>
      </li>
    );
  }
}

EventTypeFilter.propTypes = {
  eventTypes: PropTypes.array.isRequired,
  eventTypeSet: PropTypes.func,
};

const mapStateToProps = (state) => ({
  ...state.events,
  selectedEventType: state.events.selectedType,
});

const mapDispatchToProps = {
  setEventTypeAndReload,
};

export default connectWithStore(
  mapStateToProps,
  mapDispatchToProps,
)(EventTypeFilter);
